import React from 'react';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet-async";
import './error.scss';

// reusable error page in the format 'error image -> error title -> error description'
const ErrorPage = ({ className, image, title, header, info, buttonText }) => {
    return (
        <div className={className}>
            <Helmet>
                <title> {title} </title>
            </Helmet>

            <div>
                {image}
            </div>

            <div>
                {header}
                {info}
            </div>
            
            {buttonText && <Button className="redirect-button" href='/tasks'> 
                {buttonText}
            </Button>}
            
        </div>
    )
}

export default ErrorPage;